/**
 * If SelectFields have a valueKey passed to their components,
 * format incoming value and parse outgoing value so that parent receives the correct format
 * but select menu shows actual option with all keys.
 */

export const formatFunction = (value: any, options: any[], valueKey: string, isMultiSelect: boolean): any => {
  switch (true) {
    // Multi Select
    case isMultiSelect && !!value && !!valueKey:
      return options.filter((option: any) => value.includes(option[valueKey]));
    case isMultiSelect && !!value && !valueKey:
      return value;
    case isMultiSelect && !value && !valueKey:
      return [];

    // Single Select
    case !isMultiSelect && !!value && !!valueKey:
      return options.find((option: any) => option[valueKey] === value);
    case !isMultiSelect && !!value && !valueKey:
      return value;
    case !isMultiSelect && !value && !valueKey:
      return undefined;
  }
};

// Set parse function if required
export const parseFunction = (option: any, valueKey: string, isMultiSelect: boolean): any => {
  switch (true) {
    // Multi Select
    case isMultiSelect && !!option && !!valueKey:
      return option.map((option: any) => option[valueKey]);
    case isMultiSelect && !!option && !valueKey:
      return option;
    case isMultiSelect && !option && !valueKey:
      return [];

    // Single Select
    case !isMultiSelect && !!option && !!valueKey:
      return option[valueKey];
    case !isMultiSelect && !!option && !valueKey:
      return option;
    case !isMultiSelect && !option && !valueKey:
      return undefined;
  }
};
